import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LockIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { bonuses, bonusesTotalValue, checkoutUrl, productPrice } from '../data/bonuses';
export function OfferStack() {
  return <section id="comprar" className="w-full scroll-mt-8 bg-cream py-20 sm:py-28" aria-labelledby="offer-title" data-id="element-129" data-mp="2kw26ypqxo2iy">
      <div className="mx-auto w-full max-w-3xl px-5 sm:px-8" data-id="element-130" data-mp="1x5pssx53h9jx">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.25
      }} transition={{
        duration: 0.6
      }} className="overflow-hidden rounded-[2rem] border border-plum/15 bg-white/70 shadow-soft" data-id="element-131" data-mp="1t4w2jx46jinv">
          <div className="bg-plum px-7 py-8 text-center text-cream sm:px-10" data-id="element-132" data-mp="1efq5aeowk2im">
            <p className="text-xs font-medium uppercase tracking-[0.28em] text-blush" data-id="element-133" data-mp="1edn551u1ct06">
              Tu kit digital completo
            </p>
            <h2 id="offer-title" className="mt-3 font-display text-3xl leading-tight sm:text-4xl" data-id="element-134" data-mp="14pv9lawzlrcd">
              eBook «Me Elijo» + 6 bonos
            </h2>
          </div>

          <div className="px-7 py-9 sm:px-10" data-id="element-135" data-mp="1eewkwnsl7kk0">
            <ul className="space-y-3" data-id="element-136" data-mp="1eg7oonm18sb4">
              <li className="flex items-start justify-between gap-4 border-b border-plum/10 pb-3" data-id="element-137" data-mp="1eh94t6hwo4zp">
                <span className="flex items-start gap-3 text-base text-ink/85" data-id="element-138" data-mp="1jfspl3krjaqh">
                  <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-clay" aria-hidden="true" data-id="element-139" data-mp="ls27uby3nngk" />
                  eBook Método Me Elijo (guía completa)
                </span>
                <span className="whitespace-nowrap text-sm text-ink/60" data-id="element-140" data-mp="vnlzun9jm201">{productPrice}</span>
              </li>
              {bonuses.map(bonus => <li key={bonus.title} className="flex items-start justify-between gap-4 border-b border-plum/10 pb-3" data-id="element-141" data-mp="273kd73br7a72">
                  <span className="flex items-start gap-3 text-base text-ink/85" data-id="element-142" data-mp="2b78mbqg1aduf">
                    <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-clay" aria-hidden="true" data-id="element-143" data-mp="byuhugpfhmgl" />
                    {bonus.title}
                  </span>
                  <span className="whitespace-nowrap text-sm text-ink/45 line-through" data-id="element-144" data-mp="l0u1zhvqp6nr">
                    {bonus.value}
                  </span>
                </li>)}
            </ul>

            <div className="mt-8 text-center" data-id="element-145" data-mp="3ohatp6fn30zl">
              <p className="text-sm uppercase tracking-[0.18em] text-ink/55" data-id="element-146" data-mp="3oic89kvv65m2">
                Valor total de los bonos{' '}
                <span className="line-through" data-id="element-147" data-mp="3kee6t3j2gipu">{bonusesTotalValue}</span>
              </p>
              <p className="mt-4 font-display text-5xl leading-none text-plum sm:text-6xl" data-id="element-148" data-mp="24axj5vvs6xj">
                {productPrice}
              </p>
              <p className="mt-2 text-sm text-ink/60" data-id="element-149" data-mp="35qt6tihhmzm5">Pago único · Acceso de por vida</p>
            </div>

            <CtaButton className="mt-8" href={checkoutUrl} label="Sí, quiero elegirme hoy" sublabel="Descarga instantánea. Sin esperas, sin envíos." data-id="element-150" data-mp="30szyaispptip" />

            <div className="mt-7 flex flex-wrap items-center justify-center gap-x-7 gap-y-2 text-xs uppercase tracking-[0.14em] text-ink/55" data-id="element-151" data-mp="1l1pcfwk90nk1">
              <span className="inline-flex items-center gap-2" data-id="element-152" data-mp="1c8lqezvjf2ds">
                <LockIcon className="h-3.5 w-3.5 text-clay" aria-hidden="true" data-id="element-153" data-mp="1c93tafcpgeuo" /> Pago seguro
              </span>
              <span className="inline-flex items-center gap-2" data-id="element-154" data-mp="1zw29rd0trmsl">
                <ZapIcon className="h-3.5 w-3.5 text-clay" aria-hidden="true" data-id="element-155" data-mp="23yqk5p56t1ro" /> Entrega inmediata
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}